module.exports = __webpack_public_path__ + "static/01-312e4f49599b1fb1e05c2b36626e35f9.jpg";